export default "__VITE_ASSET__92518033__"